module.exports = { str: "7.4.0" };



/*****************
 ** WEBPACK FOOTER
 ** ./~/auth0-js/version.js
 ** module id = 296
 ** module chunks = 0
 **/